import Base from './Base'

class DeviceActivityReport extends Base {
  static className = 'DeviceActivityReport'
  static define() {
  }
}

export default Base.createResource(DeviceActivityReport)